import eligibilityCriteriaActions from "./actions";

const initialState = {
  eligibilityCriteria: [],
};

const eligibilityCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case eligibilityCriteriaActions.SET_ELIGIBILITY_CRITERIA:
      return {
        ...state,
        eligibilityCriteria: action.payload
      };
 
    

    default:
      return state;
  }
};

export default eligibilityCriteriaReducer;